import { useEffect } from "react";
import { useVerifiedCustomerStore } from "@/customer-info";
import { getEligibility } from "@/sales-tools";
import { getReservationSid, parsePhoneNumberAttributes } from "@/sales-tools/utils";
import { getMostRecentTask, isVoiceTask, sdkEventBus } from "@/sdk";

/*
 * Experts try to scam the system without this. Traditionally, we only check eligibility after an expert confirms
 * the callers phone number. Experts figured this out and stopped confirming the customers number bc they don't want
 * to sell
 *
 * We delay the check by 10 seconds to account for EVL connection issues. If an expert has bad audio, the call briefly
 * connects and this check will fire. Then the call will disconnect. This unfairly performs an eligibility check. By
 * delaying 10 seconds, we do not perform a check in the case of audio issues
 */
export const useEligibilityPrecheck = () => {
    useEffect(() => {
        let timeout: NodeJS.Timeout;
        const sessionStartedSubscription = sdkEventBus.on("session_changed", ({ action, session }) => {
            const task = getMostRecentTask(session);
            if (action === "end" || !isVoiceTask(task)) return;

            timeout = setTimeout(() => {
                if (useVerifiedCustomerStore.getState().getVerifiedCustomer(session.id).isCustomerVerificationComplete)
                    return;
                void getEligibility({
                    customerInteractionId: task.asurionCallId,
                    partner: task.partner,
                    reservationSid: getReservationSid(task) ?? session.id,
                    sessionId: session.id,
                    ...parsePhoneNumberAttributes(task?.mdn),
                    salesChannel: task?.type,
                });
            }, 10_000);
        });

        return () => {
            clearTimeout(timeout);
            sessionStartedSubscription();
        };
    }, []);
};
